module.exports = __webpack_public_path__ + "img/square-wave.9c46bf8e.svg";